import {Component, Input} from '@angular/core';
import {TagSummaryModel} from "../../model/tagSummary.model";
import {CommonModule} from "@angular/common";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'app-tag-field',
  templateUrl: './tag-field.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
  ]
})
export class TagFieldComponent {

  @Input() tag: TagSummaryModel;
  @Input() addBoxShaddow = false;
}
